import { getServiceUrl } from '../base/utils.js';
import { $_PAGE_ } from '../base/vars.js';
let getProfilePromise = null;

class ProfileHandler {
    async getProfile(getNewRequest) {
        if (!getNewRequest && getProfilePromise) {
            return getProfilePromise;
        }
        getProfilePromise = new Promise(async(resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: this.generateEndpoint(),
                success: (result) => {
                  resolve(result);
                },
                error: (result, status, error) => {
                  reject(result, status, error);
                }
            });
        });
        return getProfilePromise;
    }
 
    async getProfilePoints() {
        getProfilePromise = new Promise(async(resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: getServiceUrl('getProfilePoints'),
                success: (result) => {
                  resolve(result);
                },
                error: (result, status, error) => {
                  reject(result, status, error);
                }
            });
        });
        return getProfilePromise;
    }
    
    generateEndpoint() {
        const portal = window.brand_id;
        const fullProfile = 
            '&includeAddresses=true' + 
            '&includeCurrencies=true' +
            '&includeAliases=true' +
            '&includeEmails=true' + 
            '&includePhones=true' + 
            '&includePreferences=true' +
            '&includePaymentCardAccounts=true';
        const lessProfile = 
            '&includeAddresses=true' +
            '&includeCurrencies=true' +
            '&includeAliases=true';
        const includePreferences = 
            '&includePreferences=true';
        const includeTiers = 
            '&includeRedemptions=false' +
            '&includeTiers=true';
        const includeRedemptionsTiersPoints = 
            '&includeRedemptions=true' +
            '&includeTiers=true' +
            '&includePointExpiry=true';
        let endpointUrl = getServiceUrl('getProfileBase');

        if (portal !== 'wr') {
            if($_PAGE_.is('.booking-page')) {
                endpointUrl += fullProfile + includeTiers + '&includeMemberLists=true';
            } else {
                endpointUrl += lessProfile + includeTiers + '&includePaymentCardAccounts=true' + '&includeMemberLists=true';
            }
            
        } else {
            if($_PAGE_.is('.my-profile-template')) {
                endpointUrl +=  fullProfile + includeRedemptionsTiersPoints;
            } else {
                endpointUrl += lessProfile + includePreferences + includeRedemptionsTiersPoints + '&includePaymentCardAccounts=true' + '&includeMemberLists=true';
            }
        }
        return endpointUrl;
    }
}

export default new ProfileHandler();
